import React, { Component } from 'react';
import * as d3 from 'd3';
import { formatDate } from '../helpers/helpers.js';

import './line.css';

class Line extends Component {
  constructor(props) {
    super(props);

    this.chart = React.createRef();

    this.draw = this.draw.bind( this );
    this.outputSVG = this.outputSVG.bind( this );
    this.viewbox = this.viewbox.bind( this );

    this.state = {
      "paths": {
        "axis": {},
        "series": []
      },
      "ready": false,
      "size": {
				"h": 0,
				"w": 0
			},
    }
  }

  componentDidMount() {
    this.viewbox();
    window.addEventListener( 'resize', this.viewbox, false );
  }
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}

  draw() {
    let xBoundaries = this.props.xBoundaries;
    let yBoundaries = this.props.yBoundaries;
    if ( !xBoundaries || !xBoundaries instanceof Array ) {
      let days = [];
      this.props.series.forEach(
        ( serie ) => {
          days.push( new Date(serie[0].date_short).getTime() );
          days.push( new Date(serie[(serie.length-1) ].date_short).getTime() );
        }
      );
      xBoundaries = [ Math.min(...days), Math.max(...days) ];
    }
    if ( !yBoundaries || !yBoundaries instanceof Array ) {
      let quantities = [];
      this.props.series.forEach(
        ( serie ) => {
          serie.forEach(
            (point) => {
              quantities.push( parseInt(point.number, 10) );
          });
        }
      );
      yBoundaries = [ Math.min( 0, Math.min(...quantities) ), Math.max(...quantities) ];
    }
    
    const topBaseY = 30;
    const bottomBaseY = this.state.size.h - (topBaseY * 2);
    const leftBaseX = 0;
    const rightBaseX = this.state.size.w - leftBaseX;
    
    let scaleY = d3.scaleLinear()
      .domain( yBoundaries )
      .range( [ bottomBaseY, topBaseY ] );
    
    let scaleX = d3.scaleLinear()
      .domain( xBoundaries )
      .range( [ leftBaseX, rightBaseX ] );

    const electionDay = new Date('2018-03-04T07:00:00').getTime();
    const electionDayX = scaleX( electionDay );
    const electionDayEnd = new Date('2018-03-04T23:00:00').getTime();
    const electionDayEndX = scaleX( electionDayEnd );
    
    let calendar = [];
    let startDay = xBoundaries[0];
    let lastDay = xBoundaries[1];

    while ( startDay < lastDay ) {
      calendar.push({
        "x": scaleX( startDay ),
        "y": bottomBaseY + 18,
        "y1": bottomBaseY,
        "y2": bottomBaseY + 5,
        "label": formatDate( startDay / 1000 )
      });
      startDay += ( 1000 * 60 * 60 * 24 * 14 );
    }

    calendar.push({
      "x": scaleX( lastDay ) - 1,
      "y": bottomBaseY + 30,
      "y1": bottomBaseY,
      "y2": bottomBaseY + 15,
      "label": formatDate( lastDay / 1000 )
    });

    calendar[0] = {
      "x": calendar[0].x + 1,
      "y": bottomBaseY + 30,
      "y1": calendar[0].y1,
      "y2": bottomBaseY + 15,
      "label": calendar[0].label
    }

    let axis = {
      x: {
        x1: leftBaseX,
        y1: bottomBaseY,
        x2: rightBaseX,
        y2: bottomBaseY,
        calendar: calendar
      }
    }

    let overlay = {
      area: {
        d: "M" + electionDayX + "," + bottomBaseY + " L" + electionDayEndX + "," + bottomBaseY + " L" + electionDayEndX + "," + topBaseY + " L" + electionDayX + "," + topBaseY + "Z"
      },
      end: {
        x1: electionDayEndX,
        y1: bottomBaseY,
        x2: electionDayEndX,
        y2: topBaseY
      },
      start: {
        x1: electionDayX,
        y1: bottomBaseY,
        x2: electionDayX,
        y2: topBaseY
      },
      markers: {
        end: {
          x1: electionDayEndX,
          y1: bottomBaseY,
          x2: electionDayEndX,
          y2: bottomBaseY + 15
        },
        start: {
          x1: electionDayX,
          y1: bottomBaseY,
          x2: electionDayX,
          y2: bottomBaseY + 15
        }
      },
      labels: {
        date: {
          text: formatDate( electionDay / 1000 ),
          x: electionDayX + ( electionDayEndX - electionDayX),
          y: bottomBaseY + 30
        },
        description: {
          text: 'Seggi aperti 7 - 23',
          x: electionDayX + ( electionDayEndX - electionDayX),
          y: bottomBaseY + 47
        }
      },
      legend: {
        pre: {
          arrow: {
            d: "M" + (electionDayX - 5) + "," + (topBaseY + 15) + " L" + (electionDayX - 10) + "," + (topBaseY + 12) + " L" + (electionDayX - 10) + "," + (topBaseY + 18) + "Z"
          },
          label: {
            text: "Prima",
            x: 2 + ( (electionDayX - 5 - 2) / 2 ),
            y: topBaseY + 10
          },
          line: {
            x1: 2,
            y1: (topBaseY + 15),
            x2: (electionDayX - 5),
            y2: (topBaseY + 15)
          },
          stopper: {
            x1: 2,
            y1: (topBaseY + 12),
            x2: 2,
            y2: (topBaseY + 18)
          }
        },
        post: {
          arrow: {
            d: "M" + (electionDayEndX + 3) + "," + (topBaseY + 15) + " L" + (electionDayEndX + 8) + "," + (topBaseY + 12) + " L" + (electionDayEndX + 8) + "," + (topBaseY + 18) + "Z"
          },
          label: {
            text: "Dopo",
            x: (electionDayEndX + 3) + ( ( this.state.size.w - 2 - (electionDayEndX + 3) ) / 2 ),
            y: topBaseY + 10
          },
          line: {
            x1: this.state.size.w - 2,
            y1: (topBaseY + 15),
            x2: (electionDayEndX + 5),
            y2: (topBaseY + 15)
          },
          stopper: {
            x1: this.state.size.w - 2,
            y1: (topBaseY + 12),
            x2: this.state.size.w - 2,
            y2: (topBaseY + 18)
          }
        }
      }
    }

    let series = [];
    const keywordLine = d3.line()
      .x( point => point.x )
      .y( point => point.y )
      .curve( d3.curveBasis );

    this.props.series.forEach(
      (serie) => {
        let points = [];
        serie.forEach(
          (point) => {
            points.push({
              x: scaleX( new Date(point.date_short).getTime() ),
              y: scaleY( point.number )
            });
          }
        );
        series.push( {
          points,
          path: {
            d: keywordLine( points )
          }
        } );
      }
    );

    this.setState(
      { paths: { axis, overlay, series }, ready: true }
    );
  }

  outputSVG() {
    if ( this.state.ready) {
      return (
        <svg viewport={"0 0 " + this.state.size.w + ' ' + this.state.size.h} preserveAspectRatio="xMidYMid meet" width={this.state.size.w} height={this.state.size.h}>
          <g className="axis">
            <g className="x-axis">
              <line
                x1={this.state.paths.axis.x.x1}
                y1={this.state.paths.axis.x.y1}
                x2={this.state.paths.axis.x.x2}
                y2={this.state.paths.axis.x.y2} />
              <g className="x-axis--calendar">
                {
                  this.state.paths.axis.x.calendar.map(
                    (day,index) => {
                      return (
                        <g key={day.label + index}>
                          <line
                            x1={day.x}
                            y1={day.y1}
                            x2={day.x}
                            y2={day.y2}
                            className="calendar-marker" />
                          <text
                            x={day.x}
                            y={day.y}
                            className="calendar-label">{day.label}</text>
                        </g>
                      )
                    }
                  )
                }
              </g>
            </g>
          </g>
          <g className="series">
            { this.state.paths.series.map(
              (serie,index) => {
                return (
                  <g key={"serie-" + index} className={"series--serie serie-" + index}>
                    <path d={serie.path.d} />
                  </g>
                )
              }
            )}
          </g>
          <g className="election-day overlay">
            <path
              d={this.state.paths.overlay.area.d} />
            
            <line
              x1={this.state.paths.overlay.start.x1}
              y1={this.state.paths.overlay.start.y1}
              x2={this.state.paths.overlay.start.x2}
              y2={this.state.paths.overlay.start.y2} /> 
            
            <line
                x1={this.state.paths.overlay.end.x1}
                y1={this.state.paths.overlay.end.y1}
                x2={this.state.paths.overlay.end.x2}
                y2={this.state.paths.overlay.end.y2} /> 
            
            <line className="election-day--marker"
              x1={this.state.paths.overlay.markers.start.x1}
              y1={this.state.paths.overlay.markers.start.y1}
              x2={this.state.paths.overlay.markers.start.x2}
              y2={this.state.paths.overlay.markers.start.y2} /> 
            
            <line className="election-day--marker"
                x1={this.state.paths.overlay.markers.end.x1}
                y1={this.state.paths.overlay.markers.end.y1}
                x2={this.state.paths.overlay.markers.end.x2}
                y2={this.state.paths.overlay.markers.end.y2} /> 

            <text className="election-day--label"
              x={this.state.paths.overlay.labels.date.x}
              y={this.state.paths.overlay.labels.date.y}>{this.state.paths.overlay.labels.date.text}</text>

            <text className="election-day--label"
              x={this.state.paths.overlay.labels.description.x}
              y={this.state.paths.overlay.labels.description.y}>{this.state.paths.overlay.labels.description.text}</text>
          </g>
          <g className="time-markers overlay">
             <g className="time-markers--pre">
                <path className="time-markers--arrow"
                  d={this.state.paths.overlay.legend.pre.arrow.d} />
                
                <line className="time-markers--stopper"
                  x1={this.state.paths.overlay.legend.pre.stopper.x1}
                  y1={this.state.paths.overlay.legend.pre.stopper.y1}
                  x2={this.state.paths.overlay.legend.pre.stopper.x2}
                  y2={this.state.paths.overlay.legend.pre.stopper.y2} />
                
                <line className="time-markers--line"
                  x1={this.state.paths.overlay.legend.pre.line.x1}
                  y1={this.state.paths.overlay.legend.pre.line.y1}
                  x2={this.state.paths.overlay.legend.pre.line.x2}
                  y2={this.state.paths.overlay.legend.pre.line.y2} />

                <text className="time-markers--label"
                  x={this.state.paths.overlay.legend.pre.label.x}
                  y={this.state.paths.overlay.legend.pre.label.y}>{this.state.paths.overlay.legend.pre.label.text}</text>
             </g>
             <g className="time-markers--post">
                <path className="time-markers--arrow"
                  d={this.state.paths.overlay.legend.post.arrow.d} />
                
                <line className="time-markers--stopper"
                  x1={this.state.paths.overlay.legend.post.stopper.x1}
                  y1={this.state.paths.overlay.legend.post.stopper.y1}
                  x2={this.state.paths.overlay.legend.post.stopper.x2}
                  y2={this.state.paths.overlay.legend.post.stopper.y2} />
                
                <line className="time-markers--line"
                  x1={this.state.paths.overlay.legend.post.line.x1}
                  y1={this.state.paths.overlay.legend.post.line.y1}
                  x2={this.state.paths.overlay.legend.post.line.x2}
                  y2={this.state.paths.overlay.legend.post.line.y2} />

                <text className="time-markers--label"
                  x={this.state.paths.overlay.legend.post.label.x}
                  y={this.state.paths.overlay.legend.post.label.y}>{this.state.paths.overlay.legend.post.label.text}</text>
             </g>
          </g>
        </svg>
      );
    }
    return null;
  }

  viewbox() {
    let svgWrapper = this.chart.current;
    let size = {
      "h": svgWrapper.offsetHeight,
      "w": svgWrapper.offsetWidth,
    }
    this.setState(
      { size },
      () => {
        this.draw();
      }
    );
  }

  render() {
    return (
      <div className="line" ref={this.chart}>
        {this.outputSVG()}
      </div>
    );
  }
}

export default Line;


// WEBPACK FOOTER //
// ./src/Elezioni/charts/line.js